import React from "react";
import GlobalStyles from "../styles/GlobalStyles";
import Router from "./Router";

const App = () => {
  return (
    <>
      <Router />
      <GlobalStyles />
    </>
  );
};
export default App;
